// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"854":"fbed83b6","1706":"fbed83b6","3199":"fbed83b6","4987":"fbed83b6","8010":"fbed83b6","9036":"9d0db338"}[chunkId] + ".chunk.css";
};